/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Filter_Area_MinInputs */

const cs_filter_area_min = /** @type {(inputs: Filter_Area_MinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plocha od (m²)`)
};

const en_filter_area_min = /** @type {(inputs: Filter_Area_MinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Area from (m²)`)
};

/**
* | output |
* | --- |
* | "Area from (m²)" |
*
* @param {Filter_Area_MinInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const filter_area_min = /** @type {((inputs?: Filter_Area_MinInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Filter_Area_MinInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_filter_area_min(inputs)
	return cs_filter_area_min(inputs)
});